import Vue from 'vue'
import VueI18n from 'vue-i18n'

import en from './lang/en.json'
import zhhk from './lang/zh-hk.json'
import zhcn from './lang/zh-cn.json'
import jp from './lang/jp.json'
import de from './lang/de.json'
import tb from './lang/tb.json'

Vue.use(VueI18n)

const messages = {
    'en': en,
    'zh-hk': zhhk,
    'zh-cn': zhcn,
    'jp': jp,
    'de': de,
    'tb': tb
}

const i18n = new VueI18n({
    locale: localStorage.getItem('locale') || 'en',
    fallbackLocale: 'en',
    messages
})

export default i18n